module.exports = __webpack_public_path__ + "static/img/zp_06new.078367d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kit/zp_06new.png
// module id = HLrw
// module chunks = 4